routes.$inject = ['$stateProvider', '$urlRouterProvider', '$locationProvider']

// config file
import GlobalConfig from '../../../../../globals/globalConfig.json'

export default function routes ($stateProvider, $urlRouterProvider, $locationProvider) {
  const stages = GlobalConfig.workplanStages
  $locationProvider.html5Mode(true)
  $stateProvider
  .state('fullscreen.workPlanReview', {
    abstract: false,
    tag: stages.review,
    url: '/workplanReview',
    template: '<list-panel></list-panel>',
    data: {
      displayName: 'Inicio',
      label: 'Revisión'
    }
  })
  .state('fullscreen.workPlanApproval', {
    abstract: false,
    tag: stages.approval,
    url: '/workplanApproval',
    template: '<list-panel></list-panel>',
    data: {
      displayName: 'Inicio',
      label: 'Aprobación'
    }
  })
  .state('fullscreen.workPlanExecution', {
    abstract: false,
    tag: stages.execution,
    url: '/workplanExecution',
    template: require('./templates/execution.html'),
    controller: 'ExecutionCtrl',
    controllerAs: 'executionVm',
    data: {
      displayName: 'Inicio',
      label: 'Ejecución'
    }
  })
  .state('fullscreen.workPlanReviewExecution', {
    abstract: false,
    tag: stages.reviewExecution,
    url: '/workplanReviewExecution',
    template: '<list-panel></list-panel>',
    data: {
      displayName: 'Inicio',
      label: 'Revisión de la ejecución'
    }
  })
  .state('fullscreen.workPlanEvaluation', {
    abstract: false,
    tag: stages.evaluation,
    url: '/workplanEvaluation',
    template: '<list-panel></list-panel>',
    data: {
      displayName: 'Inicio',
      label: 'Evaluación'
    }
  })
  .state('fullscreen.workplanList', {
    abstract: false,
    tag: stages.consultant,
    url: '/workplanList',
    template: '<list-panel></list-panel>',
    data: {
      displayName: 'Inicio',
      label: 'Planes de Trabajo'
    }
  })
  .state('workplan.history', {
    abstract: false,
    url: '/history',
    template: '<history></history>',
    data: {
      displayName: 'Ver resumen',
      title: 'Resumen',
      order: 6,
      siblings: [
        {
          name: 'fullscreen.workPlanGeneralInformation',
          order: 0
        },
        {
          name: 'workplan.teaching',
          order: 1
        },
        {
          name: 'workplan.academicManagement',
          order: 4
        },
        {
          name: 'workplan.consolidationCP',
          order: 5
        },
        {
          name: 'workplan.investigation',
          order: 2
        },
        {
          name: 'workplan.extensionAndVisibility',
          order: 3
        }
      ]
    },
    params: {
      inHistory: true,
      stage: GlobalConfig.workplanStages.planning
    }
  })
  .state('workplan.executionHistory', {
    abstract: false,
    url: '/historyExecution',
    template: '<history></history>',
    data: {
      displayName: 'Ver resumen',
      title: 'Resumen',
      order: 6,
      siblings: [
        {
          name: 'fullscreen.workPlanExecution',
          order: 0
        },
        {
          name: 'workplan.executionTeaching',
          order: 1
        },
        {
          name: 'workplan.executionAcademicManagement',
          order: 4
        },
        {
          name: 'workplan.executionConsolidation',
          order: 5
        },
        {
          name: 'workplan.executionInvestigation',
          order: 2
        },
        {
          name: 'workplan.executionExtension',
          order: 3
        }
      ]
    },
    params: {
      inHistory: true,
      stage: GlobalConfig.workplanStages.execution
    }
  })
// States from Summaries from stages
  .state('workplan.summaryReview', {
    abstract: false,
    url: '/summaryReview/teacher/:teacherId?name/workplan/:workplanId',
    template: require('./summary/summary.html'),
    controller: 'SummaryCtrl',
    controllerAs: 'summaryVm',
    module: GlobalConfig.modules.teaching,
    data: {
      displayName: 'Resumen',
      order: 6,
      title: 'Resumen',
      siblings: [
        {
          name: 'fullscreen.workPlanReview',
          order: 0,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.reviewTeaching',
          order: 1,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.reviewAcademicManagement',
          order: 4,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.reviewConsolidation',
          order: 5,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.reviewInvestigation',
          order: 2,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.reviewExtension',
          order: 3,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        }
      ]
    },
    params: {
      stage: GlobalConfig.workplanStages.review,
      stageId: GlobalConfig.workplanIdStages.review,
      inHistory: false
    }
  })
  .state('workplan.summaryReviewExecution', {
    abstract: false,
    url: '/summaryReviewExecution/teacher/:teacherId?name/workplan/:workplanId',
    template: require('./summary/summary.html'),
    controller: 'SummaryCtrl',
    controllerAs: 'summaryVm',
    module: GlobalConfig.modules.teaching,
    data: {
      displayName: 'Resumen',
      order: 6,
      title: 'Resumen',
      siblings: [
        {
          name: 'fullscreen.workPlanReviewExecution',
          order: 0,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.reviewExecutionTeaching',
          order: 1,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.reviewExecutionAcademicManagement',
          order: 4,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.reviewExecutionConsolidation',
          order: 5,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.reviewExecutionInvestigation',
          order: 2,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.reviewExecutionExtension',
          order: 3,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        }
      ]
    },
    params: {
      stage: GlobalConfig.workplanStages.reviewExecution,
      stageId: GlobalConfig.workplanIdStages.reviewExecution,
      inHistory: false
    }
  })
  .state('workplan.summaryApproval', {
    abstract: false,
    url: '/summaryApproval/teacher/:teacherId?name/workplan/:workplanId',
    template: require('./summary/summary.html'),
    controller: 'SummaryCtrl',
    controllerAs: 'summaryVm',
    module: GlobalConfig.modules.teaching,
    data: {
      displayName: 'Resumen',
      order: 6,
      title: 'Resumen',
      siblings: [
        {
          name: 'fullscreen.workPlanApproval',
          order: 0
        },
        {
          name: 'workplan.approvalTeaching',
          order: 1,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.approvalAcademicManagement',
          order: 4,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.approvalConsolidation',
          order: 5,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.approvalInvestigation',
          order: 2,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.approvalExtension',
          order: 3,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        }
      ]
    },
    params: {
      stage: GlobalConfig.workplanStages.approval,
      stageId: GlobalConfig.workplanIdStages.approval,
      inHistory: false
    }
  })
  .state('workplan.summaryEvaluation', {
    abstract: false,
    url: '/summaryEvaluation/teacher/:teacherId?name/workplan/:workplanId',
    template: require('./summary/summary.html'),
    controller: 'SummaryCtrl',
    controllerAs: 'summaryVm',
    module: GlobalConfig.modules.teaching,
    data: {
      displayName: 'Resumen',
      order: 6,
      title: 'Resumen',
      siblings: [
        {
          name: 'fullscreen.workPlanEvaluation',
          order: 0
        },
        {
          name: 'workplan.evaluationTeaching',
          order: 1,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }

        },
        {
          name: 'workplan.evaluationAcademicManagement',
          order: 4,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.evaluationConsolidation',
          order: 5,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.evaluationInvestigation',
          order: 2,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.evaluationExtension',
          order: 3,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        }
      ]
    },
    params: {
      stage: GlobalConfig.workplanStages.evaluation,
      stageId: GlobalConfig.workplanIdStages.evaluation,
      inHistory: false
    }
  })
  .state('workplan.summaryExecution', {
    abstract: false,
    url: '/summaryExecution',
    template: require('./summary/summary.html'),
    controller: 'SummaryCtrl',
    controllerAs: 'summaryVm',
    module: GlobalConfig.modules.teaching,
    data: {
      displayName: 'Resumen',
      order: 6,
      title: 'Resumen',
      siblings: [
        {
          name: 'fullscreen.workPlanExecution',
          order: 0
        },
        {
          name: 'workplan.executionTeaching',
          order: 1
        },
        {
          name: 'workplan.executionAcademicManagement',
          order: 4
        },
        {
          name: 'workplan.executionConsolidation',
          order: 5
        },
        {
          name: 'workplan.executionInvestigation',
          order: 2
        },
        {
          name: 'workplan.executionExtension',
          order: 3
        }
      ]
    },
    params: {
      stage: GlobalConfig.workplanStages.review,
      stageId: GlobalConfig.workplanIdStages.review,
      inHistory: false
    }
  })

  .state('workplan.summaryConsult', {
    abstract: false,
    url: '/summaryConsult/teacher/:teacherId?name/workplan/:workplanId/:currentStage',
    template: require('./summary/summary.html'),
    controller: 'SummaryCtrl',
    controllerAs: 'summaryVm',
    module: GlobalConfig.modules.teaching,
    data: {
      displayName: 'Resumen',
      title: 'Resumen',
      order: 1,
      siblings: [
        {
          name: 'workplan.consultHistory',
          order: 2,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name',
            currentStage: 'currentStage'
          }
        }
      ]
    },
    params: {
      stage: GlobalConfig.workplanStages.consultant,
      stageId: GlobalConfig.workplanIdStages.consultant,
      inHistory: false
    }
  })

  .state('workplan.consultHistory', {
    abstract: false,
    url: '/consultHistory/teacher/:teacherId?name/workplan/:workplanId/:currentStage',
    template: '<history></history>',
    data: {
      displayName: 'Ver resumen',
      title: 'Resumen',
      order: 2,
      siblings: [
        {
          name: 'workplan.summaryConsult',
          order: 1,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name',
            currentStage: 'currentStage'
          }
        }
      ]
    },
    params: {
      inHistory: true,
      stageId: GlobalConfig.workplanIdStages.consultant
    }
  })

}



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/partials/review/review.route.js